import { render, staticRenderFns } from "./brandAutocomplete.vue?vue&type=template&id=20bdd18e&scoped=true&lang=html&"
import script from "./brandAutocomplete.vue?vue&type=script&lang=js&"
export * from "./brandAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./brandAutocomplete.vue?vue&type=style&index=0&id=20bdd18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bdd18e",
  null
  
)

export default component.exports